import React from "react";

const FloorPlans = () => {
  const floorPlans = [
    "/media/images/0196d97b-5e05-73e2-8ce0-8833d1f0d6c2.jpeg",
    "/media/images/0196d97b-5d8a-718c-8cd0-937df75e4d66.jpeg",
    "/media/images/0196da9c-da43-7259-8a7b-a4071df29f79.jpeg",
    "/media/images/0196e8f9-8167-700e-8f56-4e88414b7919.jpeg"
  ];

  return (
    <section id="floorplans" style={{ padding: "2rem", backgroundColor: "#f5f5f5" }}>
      <h2 style={{ textAlign: "center", marginBottom: "2rem" }}>Floor Plans</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1rem" }}>
        {floorPlans.map((plan, index) => (
          <img key={index} src={plan} alt={`Floor Plan ${index + 1}`} style={{ width: "100%", height: "auto" }} />
        ))}
      </div>
    </section>
  );
};

export default FloorPlans;